import React from 'react';
import { Link } from 'react-router-dom';
import { KeyRound } from 'lucide-react';

export default function ForgotPassword() {
  return (
    <div data-testid="forgot-page" className="max-w-md mx-auto px-4 sm:px-6 py-20 text-center">
      <div className="card-embossed p-10">
        <KeyRound className="mx-auto text-[#D4AF37]" size={38} />
        <h1 className="mt-4 font-serif-display text-3xl font-black text-gold-gradient">Forgot password?</h1>
        <p className="mt-3 text-[#C0C0C0]">
          Password reset is coming soon. For now, please contact <span className="text-[#D4AF37]">support@goldenfish.co.za</span> to recover your account.
        </p>
        <Link to="/login" className="btn-ghost-gold mt-6 inline-block">Back to login</Link>
      </div>
    </div>
  );
}
